import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getWorkOsUserById,
  addEntityAcess,
  getEntityAcess,
  removeEntityAcess,
  setUserData,
} from "../../components/settings/users/invite-modal/InviteModalSlice";
import { fetchServices } from "../../components/global-entities/globalEntitiesSlice";
import { fetchAllEntites } from "../MyEntityDashboard/myEntityDashboardSlice";
import { fetchLsps } from "../Lsp/actions/lspSlice";

const useUserAccess = (id = "") => {
  const dispatch = useDispatch();
  const refPanel = useRef(null);

  const entityservices = useSelector(
    (state) => state.globalEntities.entityservices,
  );
  const {
    workosuser,
    useraccess,
    userlsp,
    availableProcess = [],
    selectedProcess = [],
    updatEntity = [],
    updateBtnAvailbel = false,
    isLoading = false,
    successMsg = "",
  } = useSelector((state) => state.inviteusers);
  const allEntitiesFromState = useSelector(
    (state) => state.myentitydashboard.allentites,
  );
  const { lspList, status } = useSelector((state) => state.lsponboarding);
  const [entities, setEntities] = useState([]);
  const [isUpdateLsp, SetisUpdateLsp] = useState(false);

  const [isAuditSidebarOpen, setIsAuditSidebarOpen] = useState(false);
  const [useraccesslist, setUserAccessList] = useState([]);
  const [deleteEntity, setDeleteEntity] = useState(null);
  const [deletemodal, setDeleteModal] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [paginationFisrt, setPaginationFisrt] = useState(0);
  const [paginationRows, setPaginationRows] = useState(10);
  const [isRemoveLoading, setIsRemoveLoading] = useState(false);

  function getEntityNameById(id) {
    const entity = allEntitiesFromState.find((e) => e.id === id);
    return entity ? entity.name : null;
  }
  function getServiceIdsForEntity(entityId) {
    const entitydata = useraccess.find((u) => u.id === entityId);
    const templateSet = new Set();
    entitydata?.services?.forEach((service) => {
      service?.process_templates?.forEach((template) => {
        templateSet.add(template.id);
      });
    });
    return Array.from(templateSet) || [];
  }

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setLoadingData(true);
        try {
          await Promise.all([
            dispatch(fetchAllEntites()),
            dispatch(getEntityAcess(id)),
            dispatch(getWorkOsUserById(id)),
            dispatch(fetchServices()),
            dispatch(fetchLsps()),
          ]);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoadingData(false);
        }
      }
    };

    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    filterEntities(allEntitiesFromState);
  }, [allEntitiesFromState, useraccess]);

  useEffect(() => {
    const transformed = useraccess.map((entity) => {
      const serviceSet = new Set();
      const templateSet = new Set();

      entity.services.forEach((service) => {
        serviceSet.add(service.id);
        service?.process_templates?.forEach((template) => {
          templateSet.add(template.id);
        });
      });

      return {
        entity_id: entity.id,
        services: Array.from(serviceSet),
        process_template: Array.from(templateSet),
        created_at: entity?.created_at,
      };
    });

    dispatch(setUserData({ key: "selectedProcess", value: transformed }));
    dispatch(setUserData({ key: "availableProcess", value: transformed }));
    (dispatch(setUserData({ key: "isLoading", value: false })),
      setUserAccessList(useraccess));
  }, [useraccess]);

  useEffect(() => {
    if (successMsg) {
      const timer = setTimeout(() => {
        dispatch(setUserData({ key: "successMsg", value: "" }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [successMsg]);

  useEffect(() => {
    let flag = false;

    for (const updateItem of updatEntity) {
      const userEntity = useraccesslist.find(
        (user) => user.id === updateItem.entityId,
      );
      if (!userEntity) {
        flag = true;
        break;
      }
      const service = userEntity.services.find(
        (svc) => svc.id === updateItem.serviceId,
      );
      const processExists = service?.process_templates.some(
        (pt) => pt.id === updateItem.processId,
      );
      if (updateItem.checked) {
        if (!service || !processExists) {
          flag = true;
          break;
        }
      } else {
        if (service && processExists) {
          flag = true;
          break;
        }
      }
    }
    dispatch(setUserData({ key: "updateBtnAvailbel", value: flag }));
  }, [updatEntity, useraccesslist]);

  const filterEntities = (entities) => {
    setEntities(entities);
  };

  const searchEntity = (searchTerm) => {
    const filtered = allEntitiesFromState.filter((entity) =>
      entity.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    filterEntities(filtered);
  };

  const handleSearchAccess = (searchTerm) => {
    const filteredAccess = useraccess.filter((access) =>
      access?.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    setSearchQuery(searchTerm);
    setUserAccessList(filteredAccess);
  };

  const handlSelectedService = (event, entityId, serviceId, processId) => {
    const existingEntity = selectedProcess.find(
      (service) => service.entity_id === entityId,
    );

    if (existingEntity) {
      const updatedProcess = event
        ? [...new Set([...existingEntity.process_template, processId])]
        : existingEntity.process_template.filter((id) => id !== processId);

      if (updatedProcess.length === 0) {
        dispatch(
          setUserData({
            key: "selectedProcess",
            value: selectedProcess.filter((x) => x.entity_id !== entityId),
          }),
        );
        return;
      }

      let checkservices = allEntitiesFromState.find(
        (item) => item.id === entityId,
      )?.services;

      const matchingServiceIds = Array.from(
        new Set(
          checkservices
            .filter((service) =>
              service.process_templates.some((pt) =>
                updatedProcess.includes(pt.id),
              ),
            )
            .map((service) => service.id),
        ),
      );

      const item = selectedProcess.map((x) =>
        x.entity_id === entityId
          ? {
              ...x,
              services: matchingServiceIds,
              process_template: updatedProcess,
            }
          : x,
      );
      dispatch(setUserData({ key: "selectedProcess", value: item }));
      return;
    } else {
      const update = event
        ? [
            ...selectedProcess,
            {
              entity_id: entityId,
              services: [serviceId],
              process_template: [processId],
              created_at: new Date().toISOString(),
            },
          ]
        : selectedProcess;
      dispatch(setUserData({ key: "selectedProcess", value: update }));
      return;
    }
  };

  const handleAssignLsp = (e) => {
    const payload = {
      id,
      lsp_id: e?.target?.value?.id,
      access: selectedProcess,
    };
    SetisUpdateLsp(true);
    dispatch(addEntityAcess(payload)).then(() => {
      dispatch(getEntityAcess(id));
      SetisUpdateLsp(false);
    });
  };

  const getAccessEntitynames = () => {
    const entityNames = selectedProcess
      .filter((selected) => {
        const entityId = selected.entity_id;
        const existinprocess = getServiceIdsForEntity(entityId);
        const selectedProcessSorted = [
          ...(selected?.process_template || []),
        ].sort();
        const existingProcessSorted = [...existinprocess].sort();
        const isNewEntity = existingProcessSorted.length === 0;
        const areServicesDifferent =
          !isNewEntity &&
          JSON.stringify(selectedProcessSorted) !==
            JSON.stringify(existingProcessSorted);

        return isNewEntity || areServicesDifferent;
      })
      .map((selected) => getEntityNameById(selected.entity_id))
      .filter(Boolean);

    let formattedNames;

    if (entityNames.length === 0) {
      formattedNames = "";
    } else if (entityNames.length === 1) {
      formattedNames = entityNames[0];
    } else if (entityNames.length === 2) {
      formattedNames = entityNames.join(" and ");
    } else {
      const lastEntityName = entityNames.pop();
      formattedNames = `${entityNames.join(", ")} and ${lastEntityName}`;
    }
    if (updateBtnAvailbel) {
      dispatch(
        setUserData({
          key: "successMsg",
          value: `The user's access has been successfully updated.`,
        }),
      );
      dispatch(setUserData({ key: "updateBtnAvailbel", value: false }));
      dispatch(setUserData({ key: "updatEntity", value: [] }));
    } else {
      dispatch(
        setUserData({
          key: "successMsg",
          value: `${formattedNames} have been linked to the user profile`,
        }),
      );
    }
  };
  const handleSelection = () => {
    dispatch(setUserData({ key: "isLoading", value: false }));
    const payload = {
      id,
      access: selectedProcess,
    };
    handleCloseMenu();
    dispatch(addEntityAcess(payload)).then(() => {
      dispatch(setUserData({ key: "isLoading", value: false }));
      getAccessEntitynames();
      dispatch(getEntityAcess(id));
    });
  };

  const openDeleteModal = (entity) => {
    setDeleteEntity(entity);
    setDeleteModal(true);
  };

  const deleteUserAccess = () => {
    setIsRemoveLoading(true);
    const payload = {
      id,
      entity_id: deleteEntity?.id,
    };
    dispatch(setUserData({ key: "isLoading", value: false }));
    dispatch(removeEntityAcess(payload)).then(() => {
      dispatch(
        setUserData({
          key: "successMsg",
          value: `${deleteEntity?.name} have been removed from the user profile`,
        }),
      );
      setIsRemoveLoading(false);
      closeDeleteModal();
      dispatch(getEntityAcess(id));
    });
  };

  const paginationOnchange = (e) => {
    setPaginationFisrt(e.first);
    setPaginationRows(e.rows);
  };

  const closeDeleteModal = () => setDeleteModal(false);
  const handleCloseMenu = () => refPanel?.current?.hide();
  const handleSetMenu = (event) => refPanel?.current?.toggle(event);

  const hanleChangeUpdateAccess = (event, entityId, serviceId, processId) => {
    handlSelectedService(event, entityId, serviceId, processId);
    let updated_entities = [...updatEntity];
    const exists = updated_entities.some(
      (item) => item.entityId === entityId && item.serviceId === serviceId,
    );
    if (!exists) {
      const content = [
        ...updated_entities,
        {
          entityId: entityId,
          serviceId: serviceId,
          processId: processId,
          checked: event,
        },
      ];
      dispatch(setUserData({ key: "updatEntity", value: content }));
    } else {
      const output = updated_entities.some(
        (item) =>
          item.entityId === entityId &&
          item.serviceId === serviceId &&
          item.processId === processId,
      )
        ? updated_entities.map((item) =>
            item.entityId === entityId &&
            item.serviceId === serviceId &&
            item.processId === processId
              ? { ...item, checked: event }
              : item,
          )
        : [
            ...updated_entities,
            { entityId, serviceId, processId, checked: event },
          ];

      dispatch(setUserData({ key: "updatEntity", value: output }));
    }
  };
  const handlTogglePayrollPlus = (
    checked,
    entityId,
    serviceId,
    templateIds = [],
  ) => {
    const existing = selectedProcess.find(
      (process) => process.entity_id === entityId,
    );
    let nextSelected = [...(selectedProcess || [])];

    if (existing) {
      const updatedSet = new Set(existing.process_template || []);

      if (checked) templateIds.forEach((id) => updatedSet.add(id));
      else templateIds.forEach((id) => updatedSet.delete(id));

      const updatedProcess = Array.from(updatedSet);

      if (updatedProcess.length === 0) {
        nextSelected = nextSelected.filter(
          (data) => data.entity_id !== entityId,
        );
      } else {
        const checkservices =
          allEntitiesFromState.find((item) => item.id === entityId)?.services ||
          [];
        const matchingServiceIds = Array.from(
          new Set(
            checkservices
              .filter((service) =>
                (service.process_templates || []).some((templates) =>
                  updatedProcess.includes(templates.id),
                ),
              )
              .map((service) => service.id),
          ),
        );

        nextSelected = nextSelected.map((data) =>
          data.entity_id === entityId
            ? {
                ...data,
                services: matchingServiceIds,
                process_template: updatedProcess,
              }
            : data,
        );
      }
    } else if (checked && templateIds.length > 0) {
      nextSelected = [
        ...nextSelected,
        {
          entity_id: entityId,
          services: [serviceId],
          process_template: templateIds,
          created_at: new Date().toISOString(),
        },
      ];
    }
    dispatch(setUserData({ key: "selectedProcess", value: nextSelected }));
  };

  const hanleUpdatePayrollPlus = (
    checked,
    entityId,
    serviceId,
    processIds = [],
  ) => {
    handlTogglePayrollPlus(checked, entityId, serviceId, processIds);
    let updated = [...(updatEntity || [])];
    const uniqueIds = Array.from(new Set(processIds));

    const indexByKey = new Map(
      updated.map((data, index) => [
        `${data.entityId}|${data.serviceId}|${data.processId}`,
        index,
      ]),
    );
    uniqueIds.forEach((id) => {
      const key = `${entityId}|${serviceId}|${id}`;
      if (indexByKey.has(key)) {
        const index = indexByKey.get(key);
        updated[index] = { ...updated[index], checked };
      } else {
        indexByKey.set(key, updated.length);
        updated.push({ entityId, serviceId, processId: id, checked });
      }
    });
    dispatch(setUserData({ key: "updatEntity", value: updated }));
  };

  const handleDiscardUpdate = () => {
    dispatch(setUserData({ key: "selectedProcess", value: availableProcess }));
    dispatch(setUserData({ key: "updatEntity", value: [] }));
  };

  return {
    searchEntity,
    handlSelectedService,
    handleSelection,
    handleCloseMenu,
    handleSetMenu,
    handleAssignLsp,
    setIsAuditSidebarOpen,
    openDeleteModal,
    closeDeleteModal,
    deleteUserAccess,
    handleSearchAccess,
    paginationOnchange,
    hanleChangeUpdateAccess,
    handleDiscardUpdate,
    handlTogglePayrollPlus,
    hanleUpdatePayrollPlus,
    states: {
      workosuser,
      entitylistLoading: status === "lsplistloading" || isUpdateLsp,
      userlsp: {
        id: userlsp?.id,
        name: userlsp?.name,
      },
      lspList: lspList?.map((item) => ({
        id: item.id,
        name: item.name,
      })),
      refPanel,
      isAuditSidebarOpen,
      entities,
      entityservices,
      isLoading,
      selectedProcess,
      useraccesslist,
      deleteEntity,
      deletemodal,
      paginationFisrt,
      paginationRows,
      updateBtnAvailbel,
      updatEntity,
      isRemoveLoading,
      successMsg,
      searchQuery,
      loadingData,
    },
  };
};

export default useUserAccess;
